import { language as lan_googleLoginBtn } from "./google-login-btn";
import { language as lan_thirdPartyRegist } from "./third-party-regist";

let language = {
    ...lan_googleLoginBtn,
    ...lan_thirdPartyRegist
};

export { language }